<template>
  <div
    class="sn-text-deprecated"
  >
    <v-text-field
      :id="snInputProps_identifier"
      v-model="response"
      v-mask="snInputProps_mask"
      :data-cy="snInputProps_identifier + '-field'"
      :data-pendo="snInputProps_pendo + '-input'"
      :autocapitalize="autocapitalize"
      :autofocus="snInputProps_autofocus"
      :class="snInputProps_classes"
      :error-messages="snInputProps_errorMessages"
      :placeholder="snInputProps_disabled ? null : snInputProps_placeholder"
      :hint="snInputProps_hint"
      :hide-details="snInputProps_hideDetails"
      :persistent-hint="!!snInputProps_hint ? true : null"
      :name="snInputProps_name"
      :required="snInputProps_required"
      :disabled="snInputProps_disabled"
      :aria-label="snInputProps_label"
      :maxlength="snInputProps_maxLength <= 0 ? undefined : snInputProps_maxLength"
      :min="snInputProps_min"
      :max="snInputProps_max"
      :type="snInputProps_type"
      :inputmode="snInputProps_inputMode"
      :pattern="snInputProps_pattern"
      :prepend-inner-icon="snInputProps_innerIcon"
      :rules="snInputProps_rules"
      :autocomplete="autocomplete"
      :validate-on-blur="snInputProps_validateOnBlur"
      :style="`width: ${width}`"
      outlined
      flat
      solo
      @mouseup="$emit('mouseup', $event)"
      @keydown="$emit('keydown', $event)"
      @keyup="$emit('keyup', $event)"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
      @change="$emit('change', $event)"
    />
  </div>
</template>

<script>
import SnInputProps from '../../props/SnInputProps'
import deprecatedMixin from '~/components/snui/v2/_deprecated/deprecatedMixin.vue'

export default {
  name: 'SnTextDeprecated',
  mixins: [deprecatedMixin],
  props: {
    ...SnInputProps,
    autocapitalize: {
      type: String,
      default: '',
      required: false
    },
    autocomplete: {
      type: String,
      default: 'nope',
      required: false
    },
    value: {
      type: [String, Number, Array],
      default: '',
      required: false
    },
    width: {
      type: String,
      default: 'auto',
      required: false
    }
  },
  data () {
    return {
      response: '',
      deprecatedMixin: {
        alternativeComponent: 'SnTextField'
      }
    }
  },
  watch: {
    value (newVal) {
      this.response = newVal
    },
    response (newVal) {
      this.$emit('input', this.response)
    }
  },
  created () {
    this.response = this.value
  }
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';

.sn-text-deprecated {
  // Bootstrap Overrides
  ::v-deep .v-input {
    fieldset {
      background: $sn-white;
    }

    .v-text-field__slot input {
      cursor: pointer !important;
      background-color: $sn-white;
      border: none;
      box-shadow: none;
      display: block;
      margin-bottom: 0;
      height: 32px;
      font-size: 16px;
    }
  }
  // End "Bootstrap Overrides"

  font-family: $font-family-primary !important;

  .v-input--is-disabled {
    ::v-deep .v-input__slot {
      background-color: $sn-gray-01;
      border: 1px solid $sn-gray-04 !important;

      .v-text-field__slot {
        input {
          color: $sn-primary-01 !important;
        }
      }
    }
  }

  ::v-deep {
    font-family: $font-family-primary !important;

    .v-input__slot {
      border: 1px solid $sn-gray-04;
      box-sizing: border-box;
      border-radius: 2px;
      min-height: 46px !important;

      & fieldset {
        border: none;
      }

      &:focus-within {
        border: 1px solid $sn-primary !important;
      }

      &:hover {
        border: 1px solid $sn-primary !important;
      }
    }

    .v-text-field__slot {
      min-height: 46px;
    }
  }

  .error--text {
    ::v-deep .v-input__slot {
      border-color: #FF5252;

      &:hover {
        border-color: #FF5252 !important;
      }
    }
  }

  ::v-deep .v-text-field__details {
    padding-left: 0 !important;
  }

  ::v-deep .v-text-field__slot {
    input {
      caret-color: $sn-primary;
    }
  }

  ::v-deep .v-messages {
    color: $sn-primary-01;

    .v-messages__message {
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 20px;
    }

    &.error--text {
      font-size: 15px;
      display: inline-flex;
      align-items: center;
      visibility: visible;

      &:before {
        content: '\26A0';
        margin-right: 5px;
        font-size: 15px;
        margin-bottom: 22px;
      }

      .v-messages__wrapper {
        display: inline-flex;
        padding-bottom: 2px;
      }
    }
  }
}
</style>
